// Utility function
function getDisplayArtistNames(song) {
  const primary = song.artistName || "Unknown Artist";

  if (Array.isArray(song.featuredArtists) && song.featuredArtists.length > 0) {
    const accepted = song.featuredArtists.filter(a => a.status === "accepted");
    if (accepted.length > 0) {
      const names = accepted.map(a => a.displayName);
      const formats = accepted.map(a => a.format || "x");
      const formatted = names.map((name, i) => `${formats[i]} ${name}`).join(" ");
      return `${primary} ${formatted}`;
    }
  }

  return primary;
}

export { getDisplayArtistNames };
